<script setup>
import { useIdle } from '@vueuse/core';
import { watch } from 'vue';
import { useI18n } from 'vue-i18n';

const { locale } = useI18n();

const { idle } = useIdle(30 * 60 * 1000);

const homepage = import.meta.env.VITE_DRUPAL_URL;
const timeout = import.meta.env.VITE_TIMEOUT;

watch(idle, (idleValue) => {
  if (idleValue && timeout == 'true') {
    const user = JSON.parse(localStorage.getItem('user'));
    const isSso = user?.is_sso === true;
    localStorage.clear();

    if (isSso) {
      // SSO : logout natif, flux IdP intact (pas de message d'inactivité).
      window.location.href = homepage + '/' + locale.value + '/user/logout';
    } else {
      // Compte classique : on porte le flag pour afficher le message sur la home.
      const destination = encodeURIComponent('/' + locale.value + '?timeout=1');
      window.location.href = homepage + '/' + locale.value + '/user/logout?destination=' + destination;
    }
  }
})
</script>

<template>
</template>
